





































































































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { Doctor } from '@/data/models/doctor.model';
import { CrudService } from '@/data/services/crud.service';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { ClassType } from 'class-transformer/ClassTransformer';
import  Note  from '../attori/note/Note.vue';
import { Actor } from '@/data/models/actor.model';
import { Search } from '@/data/models/search.model';
import { Provincia } from '@/data/models/provincia.model';
import { Comune } from '@/data/models/comune.model';
import { Page } from '@/data/models/page.model';

@Component({
	components: {
		ValidationProvider,
		ValidationObserver,
		Note
	}
})
export default class DottoreDetail extends Vue{
	@Inject('CrudService') doctorCrudService!: CrudService<Doctor>;
	@Inject('CrudService') provinciaCrudService!: CrudService<Provincia>;
	@Inject('CrudService') comuneCrudService!: CrudService<Comune>;
	
	@Prop() doctorid!: number;
	@Prop() actorid!: number;

	doctor: Doctor = new Doctor();
	actorClass: ClassType<Actor> = Actor;
	types: string[] = [];

	provinciaClass: ClassType<Provincia> = Provincia;
	comuneClass: ClassType<Comune> = Comune;
	comuneSearch: Search = new Search('comuni');
	provincia: Provincia | null = null;
	comune: Comune | null = null;
	enableEntity: boolean = false;

	constructor() {
		super();
	}

	beforeMount() {
		this.loadProvince();
		this.loadComuni();
	}

	@Watch('doctorid') 
	onDoctorChange() {
		if(this.doctorid) {
			this.loadDoctor();
		}
	}

	loadDoctor() {
		this.doctorCrudService.getEntity(Doctor, 'doctor', this.doctorid).then((result: any) => {
			if(result.id) {
				this.doctor = result;
				this.enableEntity = true;
			}
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	loadProvince() {
		const search = new Search('province');
		search.addSimpleFilter('descrizione', this.doctor.cityofresidence as string);
		this.provinciaCrudService
			.searchEntities(Provincia, 'province', search, new Page(10))
			.then(result => this.provincia = result[0]);
	}

	loadComuni() {
		const search = new Search('comuni');
		search.addSimpleFilter('provincia', this.doctor.cityofresidence as string);
		search.addSimpleFilter('descrizione', this.doctor.comune as string);
		this.comuneCrudService
			.searchEntities(Comune, 'comuni', search, new Page(100))
			.then(result => this.comune = result[0]);
	}

	onProvinciaChange() {
		if (this.provincia) {
			this.doctor.cityofresidence = this.provincia.descrizione;
			this.doctor.comune = undefined;
			this.comuneSearch.addSimpleFilter('provincia', this.provincia.descrizione as string);
		}
	}

	onComuneChange() {
		if (this.comune) this.doctor.comune = this.comune.descrizione;
	}

	onEnableEntityChange(event: any) {
		if(!event && this.doctor.id) {
			this.$buefy.dialog.confirm({
				message: this.$t('warning-doctor-delete') as string,
				type: 'is-danger',
				hasIcon: true,
				cancelText: this.$t('annulla') as string,
				onConfirm: () => {
					this.doctorCrudService
						.deleteEntity(Doctor, 'doctor', this.doctor)
						.then(() => {
							this.doctor = new Doctor();
							this.$emit('updateDoctor', this.doctor);
							this.$buefy.notification.open({
								message: '' + this.$t('doctor-deleted'),
								type: 'is-success',
							});
						})
						.catch((error) => {
							this.$buefy.notification.open({
								message: error.msg,
								type: 'is-danger',
							});
						});
				}, 
				onCancel: () => {
					this.enableEntity = true;
				}
			});
		}
	}
	
	submit() {
		const call = (this.doctor!.id) ?
			this.doctorCrudService.saveEntity(Doctor, 'doctor', this.doctor) : 
			this.doctorCrudService.createEntity(Doctor, 'doctor', this.doctor);
		call.then(result => {
			this.doctor = result;
			this.$emit('updateDoctor', this.doctor);
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

}
